var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: " 0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5EC",
    stroke: "#E5E5EC",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.198 2.818 9.36 6.57h3.762c.203 0 .289.276.123.4l-3.042 2.32 1.163 3.752c.065.202-.16.376-.325.247L8 10.969l-3.042 2.32c-.165.123-.39-.045-.325-.247l1.163-3.753-3.042-2.32c-.165-.123-.08-.399.123-.399h3.762l1.164-3.752a.204.204 0 0 1 .395 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.e5aaab6ae9fe9a30d84f3c73f54af109.svg";
export { ForwardRef as ReactComponent };